import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

import { Button } from '@new/common/ui/Button/Button';

const TITLE = 'We couldn’t load your course plan';
const DESCRIPTION = 'Something went wrong on our side. Please try again in a moment.';

interface CourseBuilderLoadErrorProps {
  onRetry: () => void;
}

export const CourseBuilderLoadError: FC<CourseBuilderLoadErrorProps> = ({ onRetry }) => (
  <div
    role="alert"
    className="mx-auto flex w-full max-w-xl flex-col items-center gap-6 px-4 py-10 text-center sm:py-16"
  >
    <span className="flex size-14 items-center justify-center rounded-xl bg-(--primary-O200)">
      <AlertCircle aria-hidden className="size-7 text-(--primary-O1000)" />
    </span>
    <div className="flex flex-col gap-2">
      <h2 className="m-0! [font-family:var(--font-arvo)]! [font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB900)!">
        {TITLE}
      </h2>
      <p className="m-0! [font-size:var(--fs-b4)]! text-(--neutral-black-NB600)!">{DESCRIPTION}</p>
    </div>
    <Button variant="primary" className="w-full sm:w-auto" text="Try again" onClick={onRetry} />
  </div>
);
